import { gql } from '@apollo/client';

export default gql`
  query profile(
    $customerId: String!
    $subscriptionSearchTypePast: ProfileSubscriptionSearchType
    $subscriptionSearchTypeCurrent: ProfileSubscriptionSearchType
  ) {
    profile(customerId: $customerId) {
      customerId
      subscriptionsHash @client
      pastSubscriptions: subscriptions(subscriptionSearchType: $subscriptionSearchTypePast) {
        bookingReference
        endDate
        startDate
        travelPassReference
        code
        status
        price
        currency
      }
      currentSubscriptions: subscriptions(subscriptionSearchType: $subscriptionSearchTypeCurrent) {
        bookingReference
        endDate
        startDate
        travelPassReference
        code
        status
        price
        currency
      }
    }
  }
`;
